





































import mixins from 'vue-typed-mixins';
import gql from 'graphql-tag';
import Store, { IMall } from '@/Store';
import BackHomeOrExit from '@/mixins/BackHomeOrExit';
import EntityPage from '@/components/EntityPage.vue';
import MallOverview from './MallOverview/index.vue';
import MallReviews from './MallReviews.vue';

const overview = 'overview';
const reviews = 'reviews';

export default mixins(BackHomeOrExit)
  .extend({
    name: 'Mall',
    props: {
      mallId: String,
    },
    data() {
      return {
        overview,
        reviews,
        images: {
          shoppingMall: require('@/assets/shopping-mall.jpg'),
        },
        details: undefined as void | IMall,
      };
    },
    computed: {
      mallName(): string {
        return (this.details && this.details.name) || '';
      },
    },
    watch: {
      details() {
        if (this.details === null) {
          this.$router.replace({ name: '404' });
        }
      },
    },
    methods: {
      onTabChange(val: number | null) {
        this.tab = val;
      },
    },
    components: {
      EntityPage,
      MallOverview,
      MallReviews,
    },
  })
  .extend({
    apollo: {
      details: {
        query: gql`
          query mallDetails($mallID: ID!) {
            findMallByID(id: $mallID) {
              id: _id
              name
              address
              description
              active
              rating
            }
          }
        `,
        variables() {
          return {
            mallID: this.mallId,
          };
        },
        skip() {
          return !this.mallId;
        },
        update(data) {
          return data.findMallByID;
        },
      },
    },
  });
